import { render } from "./BusinessClientDetails.vue?vue&type=template&id=87e8897c&scoped=true&ts=true"
import script from "./BusinessClientDetails.vue?vue&type=script&lang=ts"
export * from "./BusinessClientDetails.vue?vue&type=script&lang=ts"

import "./BusinessClientDetails.vue?vue&type=style&index=0&id=87e8897c&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e8897c"]])

export default __exports__